import React, { useEffect, useRef, useState } from 'react'
import NotificationSvg from './icons/notificationSvg'
import nStyle from './NotificationSlider.scss';
import SliderWrapper from 'jd-library/SliderWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { clickTrack } from '../../../actions/products';
import { setSlider } from './redux/action';
import { updtLbl, checkLoggedIn } from '../../../utills';
import { AddPriceCardDataonClick } from '../addpricecard.utils';
import { useHistory } from 'react-router-dom';

const NotificationSlider = ({ cardClickHandler, sliderObj }) => {

    const [notificationCount, setNotificationCount] = useState({ rej: 0, rejLbl: 'Product', noImg: 0, noImgLbl: 'Product', withOutPrice: 0, withOutPriceLbl: 'Product', noSpec: 0, noSpecLbl: 'Product', withOutDesc: 0, withOutDescLbl: 'Product', scoreLessThanHundred: 0, scoreLessThanHundredLbl: 'Product'})
    const getNotificationData = useSelector(state => state.notifications.counts)
    const user = useSelector(state => state.session?.user?.loggedUser?.userType)
    const profileObject = useSelector(state => state.session?.profileObject)
    const dispatch = useDispatch();
    let history = useHistory();
    const notifSliderRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            const sliderEl = notifSliderRef.current?.sliderRef?.current?.sliderContentRef?.current;
            if (sliderEl) {
                const firstFocusable = sliderEl.querySelector('[tabindex="0"], button:not([disabled])');
                if (firstFocusable) firstFocusable.focus();
            }
        }, 200);
        return () => clearTimeout(timer);
    }, []);
 
    const notificationLeftIconArr = [
        {
            className: 'icon-HDRback',
            onClick: () => {
                dispatch(setSlider(false))
                window.history.back();
            }
        }
    ];

    const noNotification = notificationCount?.rej == 0 && (user == 'OWNER' ? notificationCount?.noImg == 0 : true) && notificationCount?.withOutPrice == 0 && notificationCount?.noSpec == 0 && notificationCount?.withOutDesc == 0 && (user && user != "OWNER" ? notificationCount?.scoreLessThanHundred == 0 : true)

    let notifAry = [
        { title: `${notificationCount?.rej} Rejected ${updtLbl(notificationCount?.rej, notificationCount?.rejLbl) }`, desc: "Please Review & Update them", count: notificationCount?.rej, type: "reject" },
        { title: `${notificationCount?.noImg} ${updtLbl(notificationCount?.noImg, notificationCount?.noImgLbl)} without Images`, desc: "Add Images to Get More Relevant Leads", count: notificationCount?.noImg, type: "noImage" },
        { title: `${notificationCount?.withOutPrice} ${updtLbl(notificationCount?.withOutPrice, notificationCount?.withOutPriceLbl)} without Price`, desc: "Add Price to Get More Relevant Leads", count: notificationCount?.withOutPrice, type: "noPrice" },
        { title: `${notificationCount?.noSpec} ${updtLbl(notificationCount?.noSpec, notificationCount?.noSpecLbl)} without Specifications`, desc: "Add Specifications to Attract More Buyers", count: notificationCount?.noSpec, type: "noSpec" },
        { title: `${notificationCount?.withOutDesc} ${updtLbl(notificationCount?.withOutDesc, notificationCount?.withOutDescLbl)} without Description`, desc: "Add Description for Better Response from Buyers", count: notificationCount?.withOutDesc, type: "noDesc" },
        {title: `${notificationCount?.scoreLessThanHundred} ${updtLbl(notificationCount?.scoreLessThanHundred, notificationCount?.scoreLessThanHundredLbl)} with ${notificationCount?.scoreLessThanHundredLbl} Score less than 100`, desc: `Improve ${notificationCount?.scoreLessThanHundredLbl} Score to get a better payout`, count: notificationCount?.scoreLessThanHundred, type: "score=lessThanHundred"}
    ]
    if (!profileObject.isRE && profileObject.isSO && !profileObject.isSer) {
        notifAry.pop()
    }

    useEffect(() => {
        const { rejectedCount = 0, rejectedCountLbl = 'Product', imgMissingCount = 0, imgMissingCountLbl = 'Product', priceMissingCount = 0, priceMissingCountLbl = 'Product', specMissingCount = 0, specMissingCountLbl = 'Product', descMissingCount = 0, descMissingCountLbl = 'Product', scoreLessThanHundred=0, scoreLessThanHundredLbl = 'Product'} = getNotificationData
        
        setNotificationCount({ rej: rejectedCount, rejLbl: rejectedCountLbl,  noImg: imgMissingCount, noImgLbl: imgMissingCountLbl, withOutPrice: priceMissingCount, withOutPriceLbl: priceMissingCountLbl,  noSpec: specMissingCount, noSpecLbl: specMissingCountLbl,  withOutDesc: descMissingCount, withOutDescLbl: descMissingCountLbl, scoreLessThanHundred : scoreLessThanHundred, scoreLessThanHundredLbl: scoreLessThanHundredLbl})
    }, [getNotificationData])


    const handleNotificationClick = (type) => {
        if (type == "reject") {
            sliderObj({ name: `Rejected ${notificationCount.rejLbl}`, slidertype: 'rejectedCount', fromNotification: true })
            cardClickHandler({ filter: `&tab=rejected`, name: `Rejected ${notificationCount.rejLbl}`, count: getNotificationData?.rejectedCount, type: 'rejectedCount' })
            dispatch(clickTrack({li: 'rejected_prod', ll: 'dc_notifications', userBasedCheck: true}))
        } else if (type == "noImage") {
            sliderObj({ name: 'Add Image', slidertype: 'imgMissingCoun', fromNotification: true })
            cardClickHandler({ filter: `&imagePresent=no`, name: `Add Image`, count: getNotificationData?.imgMissingCount, type: 'imgMissingCoun' })
            dispatch(clickTrack({li: 'prod_wo_img', ll: 'dc_notifications', userBasedCheck: true}))
        } else if (type == "noPrice") {
            checkLoggedIn({
                cb: async () => {
                    await AddPriceCardDataonClick();
                    dispatch(clickTrack({li: 'prod_wo_price', ll: 'dc_notifications', userBasedCheck: true}))
                },
                history
            })
        } else if (type == "noSpec") {
            sliderObj({ name: 'Add Specification', slidertype: 'specMissingCount', fromNotification: true })
            cardClickHandler({ filter: `&specPresent=no`, name: `Add Specification`, count: getNotificationData?.specMissingCount, type: 'specMissingCount' })
            dispatch(clickTrack({li: 'prod_wo_spec', ll: 'dc_notifications', userBasedCheck: true}))
        } else if (type == "noDesc") {
            sliderObj({ name: 'Add Description', slidertype: 'descMissingCount', fromNotification: true })
            cardClickHandler({ filter: `&descPresent=no`, name: `Add Description`, count: getNotificationData?.descMissingCount, type: 'descMissingCount' })
            dispatch(clickTrack({li: 'prod_wo_desc', ll: 'dc_notifications', userBasedCheck: true}))
        } else if (type == 'score=lessThanHundred'){
            sliderObj({ name: `Low ${notificationCount.scoreLessThanHundredLbl} Score`, slidertype: 'scoreLessThanHundred', fromNotification: true })
            cardClickHandler({ filter: `&score=lessThanHundred`, name: `Low ${notificationCount.scoreLessThanHundredLbl} Score`, count: getNotificationData?.scoreLessThanHundred, type: 'scoreLessThanHundred' })
            dispatch(clickTrack({li: 'prod_score_less_100', ll: 'dc_notifications', userBasedCheck: true}))
        }
    }

    return (
        <SliderWrapper
            ref={notifSliderRef}
            slider={{
                slideDirection: 'right'
            }}
            onHidden={() => dispatch(setSlider(false))}
            header={{
                heading: "Notifications",
                leftIcons: notificationLeftIconArr,
                rightIcons: []
            }}>
            <div className={nStyle["notification-slider-container"]}>
                {
                noNotification ?
                    <div className={nStyle["no-notification"]}>
                        <NotificationSvg />
                        <div className={nStyle["notification-text"]}>No New Notifications</div>
                    </div>
                    :
                    notifAry.map((item, ind) => {
                        if (item.count != 0) {
                            return ((item.type == 'score=lessThanHundred' && (!user || user == 'OWNER')) || (item.type == 'noImage' && user != 'OWNER') ? '' :
                                    <div className={nStyle["notification-contain"]} role="button" tabIndex={0} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleNotificationClick(item.type); }} onClick={() => handleNotificationClick(item.type)} key={ind}>
                                    <div className={nStyle["icon-class"]}><i className="icon-alert_outline2" /></div>
                                        <div className={nStyle["data-class"]}>
                                            <div className={nStyle["title"]}>{item.title.replaceAll('/', ' / ')}</div>
                                            <>
                                                <div className={nStyle["desc"]}>{item.desc}</div>
                                                <div className={'noti-right-arrow'} ><span className={'icon-Next'}></span></div> 
                                            </>
                                        </div>
                                    </div>
                            )
                        }
                    })
                }
            </div>
        </SliderWrapper>
    )
}

export default NotificationSlider